<template>
    <v-lazy><div class="section fade-in">
      <v-container class="px-10" fluid>
        <v-row justify="center">

          <v-col xl="5" lg="6" md="6" cols="12">
            <h2 class="section__header-title mb-15">Payment Portals</h2>
                <!-- <v-row>
                    <v-col></v-col>
                </v-row> -->
                <div class="mb-10">
                    <h3>White-Labelled</h3>
                    Create an on-brand experience for your customers - no styling required or custom development required.
                </div>
                <div class="mb-10">
                    <h3>Personalised Offers</h3>
                    Showcase personalised offers based on customer's profile and history.
                </div>
                <div class="mb-10">
                    <h3>Payment Plans</h3>
                    Allow customers to set up payment plans or instance payment processing based on your negotiation boundaries.
                </div>
                <div class="mb-10">
                    <h3>Payment Processing</h3>
                    Can be integrated with any payment gateway.
                </div>
                
                
                
                
          </v-col>
          <v-col xl="5" lg="6" md="6" cols="12" style="position: relative;">
            
            <v-img
            src="../assets/img/payment-portal-one.png"
            class="ml-auto rounded-xl elevation-6"
            max-width="400"
            contain/>
            <v-img
            src="../assets/img/payment-portal-two.png"
            class="ml-auto rounded-xl elevation-6 under-img"
            max-width="400"
            contain/>
          </v-col>
        </v-row>
      </v-container>
    </div></v-lazy>
  </template>
  <script>
  export default {
      name: 'CollectionsEngagement',
  }
  </script>
  
  <style lang="scss">
  
  .timeline-container {
    position: relative; 
    height: 10em;
  }
  .timeline-content {
    height: 100%; 
    align-items: center;
  }
  
  .under-img {
    position: absolute;
    left: 7em;
    top: 0;
    z-index: -1;
  }
  </style>